import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import { arrayCount } from "@/js/utils";

export class AutonomyTranslator {
  static sortMeetingInfo(meetingInfo) {
    const CODE = {
      KEY: "key",
      MUNICIPALITY: "municipalityCode"
    };
    if (arrayCount(meetingInfo) > 0) {
      const clonedMeetingInfo = cloneDeep(meetingInfo);
      const sortedMeetingInfo = orderBy(clonedMeetingInfo, [
        CODE.MUNICIPALITY
      ]);
      sortedMeetingInfo.forEach((info, index) => {
        info[CODE.KEY] = index + 1;
      });
      meetingInfo = cloneDeep(sortedMeetingInfo);
    }
    return {
      meeting_info: meetingInfo
    };
  }
}
